/*
 * File: ZoomInfoCard.tsx
 * Project: a-a
 * File Created: Friday, 24th October 2025 10:17:15 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Monday, 17th November 2025 11:32:54 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
  useTheme,
} from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import CustomPopOver from '../../../shared/CustomPopOver/CustomPopOver';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useState } from 'react';
import { ZoomInfoService } from '../../../../service/zoominfo.service';
import { Link } from 'react-router-dom';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';

const ZoomInfoCard = ({
  data,
  loading,
  getUpdates,
  category,
}: {
  data?: any;
  loading: boolean;
  getUpdates: any;
  category: string;
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLImageElement | null>(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [targeted, setTargeted] = useState(false);
  const [error, setError] = useState(false);
  const [alert, setAlert] = useState('');
  const handleDelete = async (id: string) => {
    // console.info('You clicked the delete icon.');

    try {
      setDeleteLoading(true);
      const res = await ZoomInfoService.deleteTarget(id);
      console.log(res);
      // setAlert('List removed successfully');
      // getTag();
    } catch (err) {
      // setAlert('Something went wrong.');
    } finally {
      setDeleteLoading(false);
      // clearTag();
      // setAnchorEl(null);
    }
  };
  const handleClick = (event: React.MouseEvent<HTMLImageElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const addTarget = async (id: string) => {
    try {
      const res = await ZoomInfoService.addTarget({ companyId: `${id}` });
      console.log(res);
      window.dispatchEvent(
        new CustomEvent('zoomInfo-targetAdded', {
          detail: {
            key: 'target-added',
            value: 'true',
            data: res,
          },
        }),
      );
      setTargeted(true);
      // getUpdates(false);
    } catch (err) {
      setError(true);
    }
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const dismissFeed = async (id: string) => {
    try {
      const res = await ZoomInfoService.dismissFeed(id);
      console.log(res);
      getUpdates(true);
    } catch (err) {
      setError(true);
    } finally {
      setAnchorEl(null);
    }
  };
  const removeTarget = async (id: string) => {
    // console.info('You clicked the delete icon.');

    try {
      const res = await ZoomInfoService.deleteTarget(id);
      console.log(res);
      setTargeted(false);
      getUpdates(true);
      setAlert('Removed target successfully');
      // getTag();
    } catch (err) {
      setError(true);
    }
  };
  return (
    <Box sx={{ borderRadius: '16px', border: `1px solid ${zeplinColor.Neutral5}` }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '8px 16px',
        }}
      >
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '5rem',
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Typography variant='responsiveBody3' color={zeplinColor.Neutral8}>
            You researched this company
          </Typography>
        )}
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '0px 8px',
              height: '32px',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            <Typography variant='responsiveButtonSmall'>Dismiss</Typography>
            <img src={`/assets/down-arrow.svg`} width='20px' height='20px' />
          </Box>
        )}
      </Box>
      <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }} />
      <Box sx={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: '16px',
            alignItems: 'center',
          }}
        >
          <Box sx={{ display: 'flex', gap: '16px' }}>
            <Box
              sx={{
                border: `1px solid ${zeplinColor.Neutral5}`,
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: zeplinColor.Neutral1,
                width: '50px',
                height: '50px',
              }}
            >
              {!loading && (
                <img
                  src={data?.logo}
                  width={'45px'}
                  height={'45px'}
                  alt={data?.name}
                  style={{ objectFit: 'contain' }}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                    e.currentTarget.style.width = '28px';
                    e.currentTarget.style.height = '28px';
                  }}
                />
              )}
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '5rem',
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveHeading4' color={zeplinColor.Brand1}>
                  {data?.name}
                </Typography>
              )}
              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    width: '5rem',
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    gap: '4px',
                    flexWrap: 'wrap',
                    maxWidth: { xs: '23rem', xl: '27rem' },
                  }}
                >
                  {data?.industries?.map((category: any) => (
                    <Chip
                      label={
                        <Typography
                          variant='responsiveLabel1'
                          sx={{ display: 'flex', alignItems: 'center' }}
                          color={zeplinColor.BasicBlack}
                        >
                          {category}
                        </Typography>
                      }
                      sx={{
                        backgroundColor: zeplinColor.Neutral4,
                        // Constants.PriorityTask[(data?.priority || 'Medium') as 'Normal' | 'Low' | 'High'],
                        color: zeplinColor.Neutral1,
                        // width: '39px',
                        // textAlign: 'left',
                        '&.MuiChip-root': {
                          height: '22px',
                          padding: '4px 8px',
                          borderRadius: '50px',

                          // margin: 0,
                          // flex: 1,
                        },
                        '& .MuiChip-label': {
                          padding: 0,
                        },
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                // Optionally adjust other styles here
              }}
            />
          ) : data?.isTargeted || targeted ? (
            <Chip
              icon={<img src={'/assets/zoominfo-check.svg'} width='18px' height='18px' />}
              label='Added to target'
              // onClick={handleClick}
              // onDelete={() => handleDelete(location?.pathname.split('/')[2] || '')}
              sx={{
                backgroundColor: zeplinColor.BasicBlack,
                color: zeplinColor.Neutral1,
                '& .MuiChip-deleteIcon': {
                  color: zeplinColor.Neutral1,
                  '&:hover': {
                    color: zeplinColor.Neutral4,
                  },
                },
                '&:hover': {
                  backgroundColor: zeplinColor.BasicBlack,
                },
              }}
            />
          ) : (
            <Box
              sx={{
                borderRadius: '28px',
                padding: '6px 12px',
                border: `1px solid ${zeplinColor.BasicBlack}`,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
              }}
              onClick={() => addTarget(data?.id)}
            >
              <img src={'/assets/add.svg'} width={'18px'} height={'18px'} alt='target account' />
              <Typography variant='responsiveButtonSmall'>Target Account</Typography>
            </Box>
          )}
        </Box>
        {loading ? (
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              // Optionally adjust other styles here
            }}
          />
        ) : (
          <Typography
            variant='responsiveBody3'
            sx={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              maxWidth: { xs: '35rem', xl: '50rem' },
            }}
          >
            {data?.descriptionList?.[0]?.description}
          </Typography>
        )}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '5rem',
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography variant='responsiveBody3' sx={{ fontWeight: 510 }}>
                Recent signals
              </Typography>
              <Link
                to={`${data?.id ?? ''}`}
                // onClick={() => console.log('data')}
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
              >
                <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                  See All
                </Typography>
              </Link>
            </Box>
          )}
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <List>
              {data?.recentSignals?.map(
                (item: any, ind: number) =>
                  ind < 2 && (
                    <ListItem sx={{ padding: '0px 0px 0px 8px', gap: '10px' }}>
                      <ListItemIcon sx={{ width: '5px', minWidth: '0px' }}>
                        <FiberManualRecordIcon
                          fontSize='small'
                          sx={{ color: zeplinColor.BasicBlack, width: '5px' }}
                        />
                      </ListItemIcon>
                      <ListItemText
                        children={
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              gap: '8px',
                            }}
                          >
                            {' '}
                            <Typography
                              variant='responsiveBody3'
                              sx={{
                                maxWidth: { xs: '30rem', xl: '35rem' },
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {' '}
                              {/* <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                        {' '}
                        Award:
                      </Typography>{' '} */}
                              {item?.summary}
                            </Typography>
                            <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
                              Last 7 days
                            </Typography>
                          </Box>
                        }
                      />
                    </ListItem>
                  ),
              )}
            </List>
          )}
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '16px',
            padding: '12px',
            borderRadius: '14px',
            backgroundColor: zeplinColor.Neutral3,
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Typography sx={{ fontSize: '14px', fontWeight: 510 }}>
                Recommended Play: {data?.recommendedPlay?.title}
              </Typography>
              <Link
                to={`${data?.id ?? ''}`}
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
              >
                <Typography variant='responsiveBody3' color={zeplinColor.Brand1}>
                  See All
                </Typography>
              </Link>
            </Box>
          )}
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <List>
              <ListItem sx={{ padding: '0px 0px 0px 8px', gap: '10px' }}>
                <ListItemIcon sx={{ width: '5px', minWidth: '0px' }}>
                  <FiberManualRecordIcon
                    fontSize='small'
                    sx={{ color: zeplinColor.BasicBlack, width: '5px' }}
                  />
                </ListItemIcon>
                <ListItemText
                  children={
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 400,
                          maxWidth: { xs: '28rem', xl: '34rem' },
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {' '}
                        {data?.recommendedPlay?.description}
                      </Typography>
                      <Link
                        to={`${data?.id ?? ''}`}
                        // onClick={() => console.log('data')}
                        style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                      >
                        <CustomButton
                          disabled={false}
                          onClick={() => {
                            //   sessionStorage.setItem('zoominfo-connecting', 'true');
                            // sessionStorage.setItem('zoominfo-auth', 'true');
                          }}
                          variant='contained'
                          color={'primary'}
                          style={{
                            // width: '95px',
                            borderRadius: '8px',
                            height: 32,
                            padding: '6px 12px',
                            //  ...(asanaConnecting && { backgroundColor: zeplinColor.Neutral3 }),
                            '&.Mui-focusVisible': {
                              backgroundColor: '#333CAA',
                              //    asanaConnecting ? zeplinColor.Neutral3 : '#333CAA',
                            },
                          }}
                          textStyle={{ color: zeplinColor.Neutral1, fontSize: '14px' }}
                          //    asanaConnecting ? zeplinColor.BasicBlack :
                          text={data?.recommendedPlay?.action}
                          // icon={<img src={`/assets/add-white.svg`} width={'13.3px'} height={'13.3px'} />}
                          // tabindex={4}
                        />
                      </Link>
                    </Box>
                  }
                />
              </ListItem>
            </List>
          )}
        </Box>
      </Box>
      <CustomPopOver
        onClick={(e: any) => {
          e.stopPropagation();
        }}
        setAnchorEl={setAnchorEl}
        anchorEl={anchorEl}
        id={id}
        sx={{ borderRadius: '14px', boxShadow: 'rgba(0, 0, 0, 0.15)' }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            padding: '16px',
            backgroundColor: zeplinColor.BasicBlack,
          }}
        >
          {/* <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={() => dismissFeed(data?.id)}
          >
            <img
              src={'/assets/eye-closed-light.svg'}
              width={'18px'}
              height={'18px'}
              alt='not interested update'
            />
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              Not interested in this update.
            </Typography>
          </Box> */}
          <Box
            sx={{ display: 'flex', gap: '9px', cursor: 'pointer' }}
            onClick={() =>
              category === 'accounts' ? removeTarget(data?.id) : dismissFeed(data?.id)
            }
          >
            <img
              src={'/assets/eye-closed-light.svg'}
              width={'18px'}
              height={'18px'}
              alt='not interested company'
            />
            <Typography variant='responsiveBody3' color={zeplinColor.Neutral1}>
              {category === 'accounts'
                ? `Remove from the target.`
                : `Not interested in this company.`}
            </Typography>
          </Box>
        </Box>
      </CustomPopOver>
      <CustomAlert
        open={error || alert ? true : false}
        handleClose={() => setError(false)}
        message={
          <CustomAlertContain
            alert={error ? 'Something went wrong.' : alert ? alert : ''}
            alertIcon={
              alert ? (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              ) : (
                <img src='/assets/error.svg' width={24} height={24} />
              )
            }
            error={error}
          />
        }
        error={error}
      />
    </Box>
  );
};

export default ZoomInfoCard;
